module.exports = __webpack_public_path__ + "assets/Wordpress.ad28d74c.svg";